import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import DeviceMixin from './mixins/device'
import PortalVue from 'portal-vue'


import Ripple from 'vue-ripple-directive'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)
Vue.directive('ripple', Ripple);
Vue.use(VueMeta)
Vue.use(PortalVue)
Vue.mixin(DeviceMixin)

Vue.config.productionTip = false

new Vue({ router, store, render: h => h(App) }).$mount('#app')
